import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

function scrollToTop() {
  // Blur the focused element (e.g. the footer link that was just clicked)
  // so the browser doesn't scroll back down to it after layout.
  if (document.activeElement && document.activeElement !== document.body) {
    (document.activeElement as HTMLElement).blur();
  }

  document.body.classList.remove('no-scroll');

  const root = document.getElementById('root');
  if (root) {
    root.scrollTop = 0;
  }

  const el = document.scrollingElement || document.documentElement;
  el.scrollTop = 0;
  document.body.scrollTop = 0;
  window.scrollTo(0, 0);
}

if (typeof window !== 'undefined') {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  history.listen((_location, action) => {
    if (action === 'POP') return;

    // Immediate: runs before React re-renders
    scrollToTop();

    // After React commits new content to the DOM (covers focus-induced scroll)
    requestAnimationFrame(() => {
      scrollToTop();
      requestAnimationFrame(scrollToTop);
    });
  });
}
